import useFeatureFlags from 'hooks/feature-flags/useFeatureFlags'

type DynamicLabels = {
  appTitle: string
  contactLabel: string
  contactsLabel: string
  accountingLabel: string
  balanceReportLabel: string
  legalEntityLabel: string
  legalEntitiesLabel: string
  allLegalEntitiesLabel: string
  taxLabel: string
}

export const useDynamicLabels = (): DynamicLabels => {
  const { isPublicSector } = useFeatureFlags()

  const labels: DynamicLabels = {
    appTitle: !isPublicSector ? 'Accounting' : 'Digital Asset Management',
    contactLabel: !isPublicSector ? 'Contact' : 'Counterparty',
    contactsLabel: !isPublicSector ? 'Contacts' : 'Counterparties',
    accountingLabel: !isPublicSector ? 'Accounting' : 'Lot Tracking',
    balanceReportLabel: !isPublicSector ? 'Balance Report' : 'Ledger Report',
    legalEntityLabel: !isPublicSector ? 'Legal Entity' : 'Case',
    legalEntitiesLabel: !isPublicSector ? 'Legal Entities' : 'Cases',
    allLegalEntitiesLabel: !isPublicSector ? 'All Legal Entities' : 'All Cases',
    taxLabel: !isPublicSector ? 'Tax' : 'Lot Tracking',
  }

  return labels
}
